import React, { useRef, useEffect, useState } from 'react';

const PIXELS_PER_SECOND = 45; // Same perceived speed on all screen sizes

const AlenalkiSlider = () => {
  const trackRef = useRef(null);
  const segmentRef = useRef(null);
  const offsetRef = useRef(0);
  const [segmentWidth, setSegmentWidth] = useState(0);

  const headings = [
    "Alenalki: A Trusted Digital Home for Eritrean Heritage and Community!",
    "Connecting, Preserving, Empowering - Pillar of information and cultural empowerment for Eritreans in the diaspora.",
    "Authentic Stories. Reliable News. United Community."
  ];

  const allText = headings.join(" • ");

  // Measure one segment width for seamless loop
  useEffect(() => {
    const measure = () => {
      if (segmentRef.current) {
        setSegmentWidth(segmentRef.current.offsetWidth);
      }
    };
    measure();
    const ro = new ResizeObserver(measure);
    if (segmentRef.current) ro.observe(segmentRef.current);
    window.addEventListener('resize', measure);
    return () => {
      ro.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, [allText]);

  // JS-driven marquee: constant px/s, seamless reset (no jerk)
  useEffect(() => {
    if (!segmentWidth || !trackRef.current) return;

    let rafId = null;
    let lastTime = performance.now();

    const tick = (now) => {
      const dt = (now - lastTime) / 1000;
      lastTime = now;
      offsetRef.current += PIXELS_PER_SECOND * dt;
      // Seamless loop: after one segment width, reset by that amount
      if (offsetRef.current >= segmentWidth) {
        offsetRef.current -= segmentWidth;
      }
      if (trackRef.current) {
        trackRef.current.style.transform = `translate3d(-${offsetRef.current}px, 0, 0)`;
      }
      rafId = requestAnimationFrame(tick);
    };

    rafId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafId);
  }, [segmentWidth]);

  return (
    <div className="w-full bg-gradient-to-r from-blue-500 to-yellow-400 text-white py-6 overflow-hidden">
      <div ref={trackRef} className="flex whitespace-nowrap will-change-transform">
        <span ref={segmentRef} className="text-lg font-semibold pr-16 shrink-0">
          {allText}
        </span>
        <span className="text-lg font-semibold pr-16 shrink-0">
          {allText}
        </span>
      </div>
    </div>
  );
};

export default AlenalkiSlider;
